import { createContext } from 'react';
import { CardResult } from 'api/card';

export const defaultCardResult: CardResult = {
  count: 0,
  cards: [],
};

type Props = {
  cardResult: CardResult,
};

export const CardsContext = createContext<Props>({
  cardResult: defaultCardResult,
});
